<template>
    <div><!-- 出貨單列印查詢 -->
        <SearchBar @deliverySearch="deliverySearchEvent"/>
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <router-link class="btn btn-success" @click.native="deliveryinfoEvent" to="">{{$t('Buttons.Print')}}</router-link>
                </div>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center option">{{headers[0]}}<input class="ml-2" type="checkbox" v-model="selectAll" @click="selectAllEvent"></th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center text-danger">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                            <th class="text-center">{{headers[9]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in deliverySearchResult" :key="item.proid + index">
                            <td class="text-center">
                                <label class="form-checkbox">
                                    <input type="checkbox" :value="combindKey(item)" v-model="selectedItem">
                                    <i class="form-icon"></i>
                                </label>
                            </td>
                            <td class="text-center">{{item.aedatTxt}} </td>
                            <td class="text-center">{{item.bsart + '-' + item.ebeln}}</td>
                            <td class="text-center">{{item.ebelp}}</td>
                            <td class="text-center">{{item.matnr}}</td>
                            <td class="text-center">{{item.txz01}}</td>
                            <td class="text-center text-danger">
                                  <input type="number" class="text-danger" 
                                         v-model="item.shipments" 
                                         :max="item.maxShipments" 
                                         @change="checkMaxValue(item)" ></td>
                            <td class="text-center">{{item.menge | currencyF3}}</td>
                            <td class="text-center">{{item.grqty | currencyF3}}</td>
                            <td class="text-center">{{item.eindtTxt}}</td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>        
    </div>
</template>
<script>
import SearchBar from './SearchBar'
import Information from './Information'
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            headers : [
                this.i18n('ShipmentPrinting.Check'),this.i18n('ShipmentPrinting.DocumentDate'),this.i18n('ShipmentPrinting.PurchasingDocument'),this.i18n('ShipmentPrinting.DocumentVersion'),this.i18n('ShipmentPrinting.Material'),this.i18n('ShipmentPrinting.ShortText')
                ,this.i18n('ShipmentPrinting.ShipmentsQuantity'),this.i18n('ShipmentPrinting.POQuantity'),this.i18n('ShipmentPrinting.DeliveredQuantity'),this.i18n('ShipmentPrinting.DeliveryData')
            ],            
            selectedItem: [],
            selectAll: false            
        }
    },
    components: {
        SearchBar,
        Information,
    },
    watch: {
        'lang': function() {
            this.headers = [
                this.i18n('ShipmentPrinting.Check'),this.i18n('ShipmentPrinting.DocumentDate'),this.i18n('ShipmentPrinting.PurchasingDocument'),this.i18n('ShipmentPrinting.DocumentVersion'),this.i18n('ShipmentPrinting.Material'),this.i18n('ShipmentPrinting.ShortText')
                ,this.i18n('ShipmentPrinting.ShipmentsQuantity'),this.i18n('ShipmentPrinting.POQuantity'),this.i18n('ShipmentPrinting.DeliveredQuantity'),this.i18n('ShipmentPrinting.DeliveryData')
            ]
        }
    },
    methods: {
        deliveryinfoEvent (){ //列印
            const deliverySelected= {};
            if(this.selectedItem.length >0){
                const rows= [];
                this.deliverySearchResult.forEach(e => {
                    const key= e.ebeln + '\t' + e.ebelp;
                    if(this.selectedItem.indexOf(key)>-1){
                        rows.push(e);    
                    }
                });                
                deliverySelected.rows = rows;                
                this.setCacheQueryParam('Delivery_SelectedRows' , deliverySelected);            
                this.$router.push('deliveryinformation');
            }else{
                this.$alert('請需至少選擇一項！','警告',{type: 'warning'});
            }
            
        },
        combindKey(item){
            return item.ebeln + '\t' + item.ebelp;
        },
        deliverySearchEvent (v){
            this.doDeliverySearch(v);
        },
        selectAllEvent() {
			this.selectedItem = [];
			if (!this.selectAll) {
				for(let i in this.deliverySearchResult) {
                    const item = this.deliverySearchResult[i];
					this.selectedItem.push(this.combindKey(item));
				}
			}
		},
        checkMaxValue(item) {            
            if(item) {
                if(item.shipments > item.maxShipments){
                    this.$alert('已超過應交貨數量！','警告',{type: 'warning'});
                    item.shipments = item.maxShipments
                }else if(item.shipments < 0){
                    this.$alert('不能輸入負數！','警告',{type: 'warning'});
                    item.shipments = 0;
                }
            } 
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    props : {
    },
    computed: {
        ...mapGetters(['lang'])
    },
	mounted() {      
        const queryParam = {};
        this.getCacheQueryParam('Delivery_QueryParam' , queryParam);
        this.doDeliverySearch(queryParam);
	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.option {
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-gray {
    background-color: gray;
    color: white;
}

.modal-body {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-footer {
    background-color: #fff;
}

</style>
